<template lang="pug">
  .dashboard-inner.xs-f-small.max-at-tweak.narrow-modal-body
    SectionTitle(text="Delete Address").app-modal-title
    .msg Can not delete this address because it's used for the following auto-deliver{{suffix}}:
    .row(v-for="sub in addressToDelete.subs" :key="sub.id")
      .row.prod(v-for="item in sub.items")
        .xs-12.prod-info
          p
            span.upper.bold &#183;  {{ item.product_type_name }}&nbsp;
            span {{ item.product_name }}


    .row(v-if="moreThanOneAddress")
      hr
      .xs-12.msg Select a different subscription address:

      .xs-12.addresses
        fieldset
          .row(v-for="address in addresses" v-if="address.id != addressToDelete.id")
            .choice.xs-12
              MrRadio(v-model="selectedAddress" :value="address" name="address")
                .address {{ address.street_1 }} {{ address.street_2 }} {{ address.city }}, {{address.state}} {{address.post_code}}

    .row(v-else)
      p To continue please enter a new address:
      form
        .xs-12
          AddressEditInputs(:v="$v")

    .row
      SubmitButtons(
        submit-text="Delete and Replace"
        :submit-method="onSubmit"
        cancel-text="Cancel"
        :cancel-method="onCancel")


</template>

<script>
  import { mapState, mapActions } from 'vuex';
  import AddressEditInputs from './AddressEditInputs';
  import SubmitButtons from '../SubmitButtons';
  import SectionTitle from "../SectionTitle";
  import MrRadio from "../mrRadio";

  export default {
    name: "AddressDeleteHasSubsModal",
    components: {
      MrRadio,
      SectionTitle,
      AddressEditInputs,
      SubmitButtons
    },

    data() {
      return {
        selectedAddress: {}
      }
    },

    mounted() {
      //- when user is trying to delete their last address that
      //- is associated with subs we require to enter a new
      //- replacement address (this modal is shown only when user
      // tries to delete an address with associated subs)
      if (!this.moreThanOneAddress) {
        this.$store.dispatch('addressBook/populateEditAddressForm');
      }
    },

    computed: {
      ...mapState('addressBook', [
        'addresses',
        'editAddressForm',
        'addressToDelete',
        'addressFormValidators'
      ]),

      suffix() {
        if (!this.addressToDelete.subs) {
          return;
        }

        return this.addressToDelete.subs.length > 1 ? 'ies' : 'y';
      },

      moreThanOneAddress() {
        return this.addresses.length > 1;
      }

    },

    methods: {
      ...mapActions('modal', ['hideModal']),
      ...mapActions('addressBook', [
        'deleteAddressWithSubReplace'
      ]),

      onSubmit() {
        //- if there is more than one address customer has to select one
        if (this.moreThanOneAddress && !this.selectedAddress.id) {
          return this.$store.dispatch('notifyWarn', 'Please select address to replace for all auto-deliveries');
        }

        this.$v.$touch();

        if (this.$v.$invalid) {
          return;
        }

        this.deleteAddressWithSubReplace(this.selectedAddress.id);
        this.hideModal();
      },

      cleanUp() {
        this.$store.commit('addressBook/clearAddressToDelete');
        this.$store.commit('addressBook/clearEditAddressForm');
      },

      onCancel() {
        this.hideModal();
        this.cleanUp();
      }
    },

    validations() {
      var validations = {};
      if (!this.moreThanOneAddress) {
        validations.editAddressForm = this.addressFormValidators;
      }
      return validations;
    }
  }
</script>

<style scoped lang="stylus">
  .msg
    padding 1em 0 1.5em

  .prod
    padding-bottom 1em

  .prod-img
    img
      width 100%

  .prod-info
    padding-left 0.5em

    p
      padding-bottom 0.5em

  hr
    padding-bottom 1em

  .addresses
    padding 0 0 2em 0

    .address
      display inline-block
      vertical-align top

  .choice
    padding-bottom 2em

  .new-address-btn
    margin-bottom 2em

  .address-edit-form
    margin-bottom 1.5em

</style>